import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import SideBarTab from '../SideBar/SideBarTab';
import { SideBarInner } from '../../styled-components/SideBar';
import { actions as contentActions } from '../../actions/content';
import { generateShortcutText } from '../../util/keyShortcutUtils';
import localize from '../../util/localizeUtils';

const ImagesImage = 'images/images.png';
const MoviesImage = 'images/film.png';
const DataImage = 'images/data.png';

const Mousetrap = window.Mousetrap;

class BrowseContentSideBarItem extends SideBarTab {
  render() {
    return <SideBarTab {...this.props} />;
  }
}

class BrowseContentSideBarContent extends React.Component {
  componentDidMount() {
    this.bindShortcuts();
  }

  componentWillUnmount() {
    this.unbindShortcuts();
  }

  bindShortcuts = () => {
    const { openImagesContent, openMoviesContent } = this.props.shortcuts;
    Mousetrap.bindGlobal(openImagesContent, () => this.props.loadContent('image'));
    Mousetrap.bindGlobal(openMoviesContent, () => this.props.loadContent('video'));
  };

  unbindShortcuts = () => {
    const { openImagesContent, openMoviesContent } = this.props.shortcuts;
    Mousetrap.unbind(openImagesContent);
    Mousetrap.unbind(openMoviesContent);
  };

  render() {
    const { loadContent, currentAssetType, isModifierActive } = this.props;

    /* Placeholders until config is implemented. */
    const showImage = true;
    const showMovies = true;
    const showData = false;

    return (
      <SideBarInner>
        {showImage ? (
          <BrowseContentSideBarItem
            text={generateShortcutText(localize('imagesTab'), isModifierActive)}
            image={ImagesImage}
            onClick={() => loadContent('image')}
            active={currentAssetType === 'image'}
          />
        ) : (
          ''
        )}
        {showMovies ? (
          <BrowseContentSideBarItem
            text={generateShortcutText(localize('moviesTab'), isModifierActive)}
            image={MoviesImage}
            onClick={() => loadContent('video')}
            active={currentAssetType === 'video'}
          />
        ) : (
          ''
        )}
        {showData ? (
          <BrowseContentSideBarItem
            text={generateShortcutText(localize('dataTab'), isModifierActive)}
            image={DataImage}
            onClick={() => {}}
            active={currentAssetType === 'data'}
          />
        ) : (
          ''
        )}
      </SideBarInner>
    );
  }
}

BrowseContentSideBarContent.propTypes = {
  currentAssetType: PropTypes.string.isRequired,
  loadContent: PropTypes.func.isRequired,
  shortcuts: PropTypes.shape({
    openImagesContent: PropTypes.arrayOf(PropTypes.string),
    openMoviesContent: PropTypes.arrayOf(PropTypes.string)
  }).isRequired,
  isModifierActive: PropTypes.bool.isRequired
};

const mapStateToProps = state => ({
  currentAssetType: state.content.assetType,
  shortcuts: state.keyShortcuts.shortcuts,
  isModifierActive: state.keyShortcuts.isModifierActive
});

const mapActionCreators = {
  loadContent: contentActions.loadContent
};

export default connect(mapStateToProps, mapActionCreators, null, { withRef: true })(
  BrowseContentSideBarContent
);



// WEBPACK FOOTER //
// ./app/components/ContentSelection/BrowseContentSideBarContent.js